import state from './state'
import mutations from './mutations'
import actions from './actions/index'
import getters from './getters'

import moduleNew from './new/index'
import moduleEdit from './edit/index'
import moduleSeatingStatus from './seatingStatus/index'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,

  modules: {
    new: moduleNew,
    edit: moduleEdit,
    seatingStatus: moduleSeatingStatus
  }
}
